import React from 'react';
import { Toaster } from 'sonner';

const RootApp = () => {
	return (
		<>
			<Toaster
				position='top-right'
				richColors
				closeButton
				visibleToasts={999}
				expand
			/>
		</>
	);
};

export default RootApp;
